import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import DocumentHead from 'legacyComponents/documentHead';

import { Repository } from 'apps/repository';
import { scrollHash } from 'apps/utils';

import { conf } from 'apps/project/config.yaml';

@withNamespaces()
@observer
export class FilesPage extends React.Component {
  componentDidMount() {
    scrollHash();
  }

  render() {
    const { project, projectManager, repoManager, t } = this.props;
    if (project && repoManager.repository) {
      return (
        <>
          <DocumentHead title={`${project && project.name} | Files`} />
          <Repository
            title={t(conf.sections[1])}
            projectManager={projectManager}
            repoManager={repoManager}
            project={project}
          />
        </>
      );
    }
    return (
      <>
        <DocumentHead title={`${project && project.name} | Files`} />
      </>
    );
  }
}

FilesPage.propTypes = {
  project: PropTypes.object,
  projectManager: PropTypes.object,
  repoManager: PropTypes.object,
  t: PropTypes.func,
};
